import { useEffect } from 'react';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import { isEditableTextTarget } from '@utils/isEditableTextTarget';

/**
 * Esc clears the whole multi-selection and returns the canvas to its default
 * state. Registered globally while the model canvas is mounted (model tab,
 * including what-if scenarios).
 *
 * Esc while typing in an editable field (list search, filter inputs, drawer
 * inputs) keeps its native behaviour and must not clear the selection.
 */
const useClearSelectionShortcut = () => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      if (isEditableTextTarget(document.activeElement)) return;

      if (getMultiSelectionState().selectedIds.length === 0) return;

      clearMultiSelection();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useClearSelectionShortcut;
